// extracted by mini-css-extract-plugin
module.exports = {"verticleDivider":"verticle-divider_verticleDivider__118cV"};